<template>
  <CTag theme="outline" class="c-severity-tag">
    <CColor :theme>
      <CSeverity :severity="severity"/>
      {{ getSeverityLabel(severity) }}
    </CColor>
  </CTag>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CColor from '@/shared/components/CColor.vue';
  import CSeverity from '@/shared/components/CSeverity.vue';
  import CTag from '@/shared/components/CTag.vue';
  import Severity from '@/shared/constants/Severity';
  import { getSeverityLabel } from '@/shared/utils/labels';

  const props = defineProps<{
    severity: Severity,
  }>();

  const theme = computed(() => {
    switch (props.severity) {
      case Severity.GOOD:
        return 'success';
      case Severity.CAUTION:
        return 'warning';
      case Severity.BAD:
        return 'danger';
    }
  });
</script>

<style lang="scss">
  .c-severity-tag {
    &.c-tag {
      line-height: unset;
    }
  }
</style>